module.exports = __webpack_public_path__ + "img/lady3.22b81e71.png";